






















































































































import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  name: "SearchAnime",

  props: ["mini"],
  data: () => ({
    menuData: undefined as any
  }),

  methods: {},
  computed: {
    ...mapState([
      "searchResult",
      "selectedAnime",
      "recentAnime",
      "loadingResult"
    ])
  }
});
